import React, { useEffect } from 'react';
import AOS from 'aos'
import 'aos/dist/aos.css'

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 2500, disable: 'mobile' });
  }, []);
  return (
    <div className='w-full h-[screen] bg-[#0a192f] text-gray-300'>
      <div className='flex flex-col justify-center items-center w-full h-full'>
        <div name='about' data-aos='fade' className='max-w-[1000px] w-full grid grid-cols-2 gap-8 mt-[-6rem] md:mt-[-7rem]'>
          <div className='sm:text-right pb-8 pl-4 mt-[12rem] md:mt-[13rem]'>
            <p className='text-4xl font-bold inline border-b-4 border-pink-600'>
              About
            </p>
          </div>
        </div>
        <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
          <div data-aos='fade-right' className='sm:text-right text-2xl md:text-4xl font-bold'>
            <p>Hi. I'm Ryan, nice to meet you. Please take a look around.</p>
          </div>
          <div data-aos='fade-left'>
            <p className='text-left'>Fast learner, adaptive, and professional person. Having experience in creating and
              developing an online shop, hiring app, payment app, and ticket booking app projects.
              Able to use various Javascript framework and library such as React.JS, Next.JS, Redux,
              ExpressJs, and React Native. Experienced using PostgreSQL for the database. Able to
              work together using github and Linux as a daily operating system</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
